import {Controller} from '@stubhub/react-store-provider';
import {createSelector} from 'reselect';
import {get} from '@stubhub/rest-method';

// TODO: if not using subcatnav on sell, delete this file
const ACTION_TYPES = {
  SUB_CATEGORY_LOADING: 'SUB_CATEGORY_LOADING',
  SUB_CATEGORY_LOADED: 'SUB_CATEGORY_LOADED',
  SUB_CATEGORY__RESET: 'SUB_CATEGORY__RESET'
};
const NAMESPACE = 'SubCategoryNav';

const userStateSelector = (state) => state.user;
const userLocationSelector = createSelector(userStateSelector, (user) => (user ? user.location : null));
const pointSelector = createSelector(userLocationSelector, (location) => (location ? `${location.latitude},${location.longitude}` : null));
const contentContentStateSelector = (state) => state.header;
const subCatNavSelector = createSelector(contentContentStateSelector, (user) => (user ? user.subCatNav : null));

function loadCategoryData(categoryId) {
  return (dispatch, getState) => {
    let state = getState();
    let path = '/recommendations/core/v2/events/';
    let query = {
      categoryId,
      startIndex: 0,
      limit: 6,
      maxEventsPerPerformer: 1,
      point: pointSelector(state)
    };
    let headers = {
      'Authorization': process.env.REACT_APP_API_SECRET
    };

    dispatch({type: ACTION_TYPES.SUB_CATEGORY_LOADING, isLoading: true});

    return get({
      host: process.env.REACT_APP_API_HOST,
      path,
      query,
      headers,
      json: true,
      cache: true
    }).then((/* istanbul ignore next */res = {}) => {
      let categoryData = res.events || /* istanbul ignore next */[];
      
      dispatch({type: ACTION_TYPES.SUB_CATEGORY_LOADED, isLoading: false, categoryData});
      return;
    }).catch(() => {
      dispatch({type: ACTION_TYPES.SUB_CATEGORY_LOADED, isLoading: false, categoryData: []});
    });
  };
}

/**
 * Method to Reset the Performer Page redux state.
 **/
function resetSubCatDropdown() {
  return (dispatch) => {
    dispatch({type: ACTION_TYPES.SUB_CATEGORY__RESET});
  };
}

const subCatController = new Controller({
  namespace: NAMESPACE,
  actionCreators: {
    loadCategoryData,
    resetSubCatDropdown
  },
  reducers: [ACTION_TYPES.SUB_CATEGORY_LOADING, ACTION_TYPES.SUB_CATEGORY_LOADED]
  ,
  mapStateToProps: function(state) {
    let localState = this.getLocalState(state);
    return {
      categoryData: localState.categoryData || [],
      location: userLocationSelector(state),
      merchConfig: subCatNavSelector(state) || []
    };
  }
});

subCatController.addResetReducer([ACTION_TYPES.SUB_CATEGORY__RESET]);

export default subCatController;
